import { render, staticRenderFns } from "./AssetBuilder.vue?vue&type=template&id=dea8340c"
import script from "./AssetBuilder.vue?vue&type=script&lang=js"
export * from "./AssetBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports